"use client";

// AccessSheetHost — mounted once in the dashboard. Listens for openAccess()
// (lib/self/ringEvents) and loads the access sheet the first time it is asked
// for. The private ring's people only (F.privateRing): for anyone else a press
// does nothing, and nothing is fetched.

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import { OPEN_ACCESS_EVENT, type AccessTarget } from "../../lib/self/ringEvents";

const AccessSheet = dynamic(() => import("./AccessSheet"), { ssr: false });

export default function AccessSheetHost({ enabled }: { enabled: boolean }) {
  const [target, setTarget] = useState<AccessTarget | null>(null);
  // stays mounted once used, so closing can play out
  const [used, setUsed] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    const on = (e: Event) => {
      const t = (e as CustomEvent<AccessTarget>).detail ?? {};
      setUsed(true);
      // a fresh object each time, so the sheet lands where this one asked
      setTarget({ ...t });
    };
    window.addEventListener(OPEN_ACCESS_EVENT, on);
    return () => window.removeEventListener(OPEN_ACCESS_EVENT, on);
  }, [enabled]);

  if (!enabled || !used) return null;
  return <AccessSheet target={target} onClose={() => setTarget(null)} />;
}
